export const arrayToObject = <T extends { id: string | number }>(array: T[]) =>
  array.reduce((obj: Record<string, T>, item) => {
    obj[item.id] = item;
    return obj;
  }, {});
